import { useRef } from "react";
import { useDispatch } from "react-redux";
import GeneralForm from "../../components/general-form/general-form";
import CustomButton from "../../components/custom-button/custom-button";
import { login } from "../../store/features/auth/authSlice";

export default function Login() {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const fields = [
    {
      name: "email",
      type: "email",
      label: "Email",
      isRequired: true,
    },
    {
      name: "password",
      type: "password",
      label: "Mật khẩu",
      isRequired: true,
    },
  ];

  const onSubmit = (data) => {
    dispatch(login(data));
  };

  const handleLoginClick = async () => {
    await formRef.current.submitForm();
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md bg-white shadow-xl rounded-lg p-6">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Ji miso
          <br />
          <span className="text-lg font-normal">Đăng nhập</span>
        </h1>

        <GeneralForm
          ref={formRef}
          props={{
            fields: fields,
            onSubmit: onSubmit,
            hiddenSubmitBtn: true,
          }}
        />

        <div className="w-full flex flex-row justify-end gap-2 mt-4">
          <div className="w-32">
            <CustomButton
              props={{
                title: "Đăng nhập",
                onClick: handleLoginClick,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
